import styled from 'styled-components';

export const MinimizedViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .header {
    display: flex;
    justify-content: space-between;
    min-height: 54px;
    margin: ${({ theme: { token } }) => token.margin}px;

    .left {
      display: flex;
      gap: 16px;

      .device-info {
        display: flex;
        flex-direction: column;
        gap: ${({ theme: { token } }) => token.marginXS}px;
      }

      .device-name {
        font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
      }

      .device-model {
        font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
        color: ${({ theme: { token } }) => token.colorTextDescription};
      }
    }

    .right {
      display: flex;
      align-items: center;
      gap: 10px;

      .drawer-details-header-buttons {
        display: flex;
        align-items: center;
        gap: ${({ theme: { token } }) => token.marginXS}px;
      }
    }
  }

  .body {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
    flex-grow: 1;
    gap: ${({ theme: { token } }) => token.marginLG}px ${({ theme: { token } }) => token.marginXL}px;
    padding: ${({ theme: { token } }) => token.marginXL}px ${({ theme: { token } }) => token.marginXXL}px;
  }
`;
